import React from "react";
import { useMutation } from "react-query";
import { assignUser } from "./gateway";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";

export default function useAssignCase(
  setOpenAssign: React.Dispatch<React.SetStateAction<boolean>>,
) {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: assignUser,
    onSuccess: async () => {
      enqueueSnackbar(t("Επιτυχής ανάθεση χρήστη"), { variant: "success" });
      setOpenAssign(false);
      await queryClient.invalidateQueries("manageCaseApplication");
    },
  });
}
